import clsx from "clsx";
import { CSSProperties } from "react";
import { Dropdown } from "react-bootstrap";
import DropdownItem from "react-bootstrap/esm/DropdownItem";
import { useNavigate } from "react-router";
import { Icon, RenderWhen } from "../../../../../components";
import { LOCATION } from "../../../../search/consts";
import { SECTIONS } from "../../../consts";
import { useLocalSampleSummaryParams } from "../../../hooks";
import { getSearchPivotLink, pathToSS } from "../../../util";
import styles from "./file-similarity.module.scss";

type Item = {
  id: string;
  label: string;
  query: string;
};

type Props = {
  className?: string;
  menuStyle?: CSSProperties;
  label: string;
  items: Array<Item>;
  hasRha?: boolean;
  hasTlsh?: boolean;
  hasSsdeep?: boolean;
};

const FileSimilarityFilter = ({
  hasRha,
  hasTlsh,
  hasSsdeep,
  className,
  menuStyle,
  items,
  label
}: Props) => {
  const { hash, sourceId } = useLocalSampleSummaryParams();
  const navigate = useNavigate();

  const goToRHAPage = () => {
    const path = pathToSS(hash, sourceId, SECTIONS.THREAT_INTELLIGENCE.RHA);
    navigate(path);
  };

  const goToTLSHPage = () => {
    const path = pathToSS(hash, sourceId, SECTIONS.THREAT_INTELLIGENCE.TLSH);
    navigate(path);
  };

  const goToSsdeepPage = () => {
    const path = pathToSS(hash, sourceId, SECTIONS.THREAT_INTELLIGENCE.SSDEEP);
    navigate(path);
  };

  return (
    <Dropdown id={styles.dropdown} className={clsx("primary", className)}>
      <Dropdown.Toggle
        id={`rha-to-search-filters`}
        data-testid="rha_to_search_filters"
        variant="link"
      >
        {label}{" "}
        <Icon name="chevron-down" className="dropdown-toggle__chevron-icon" />
      </Dropdown.Toggle>
      <Dropdown.Menu
        renderOnMount
        data-testid="rha_to_search_filters_menu"
        style={menuStyle}
      >
        <RenderWhen condition={Boolean(hasRha)}>
          <DropdownItem
            onClick={goToRHAPage}
            data-testid="rha_to_search_filter_item_similar_by_rha_hash_similarity"
          >
            Similar by RHA Hash (by similarity)
          </DropdownItem>
        </RenderWhen>
        {items.map(item => (
          <Dropdown.Item
            key={item.label}
            href={getSearchPivotLink(item.query, {}, false, LOCATION.CLOUD)}
            target="_blank"
            data-testid={`rha_to_search_filter_item_${item.id}`}
          >
            {item.label}
          </Dropdown.Item>
        ))}
        <RenderWhen condition={Boolean(hasTlsh)}>
          <DropdownItem
            onClick={goToTLSHPage}
            data-testid="tlsh_to_search_filter_item_similar_by_tlsh_hash_similarity"
          >
            Similar by TLSH Hash
          </DropdownItem>
        </RenderWhen>
        <RenderWhen condition={Boolean(hasSsdeep)}>
          <DropdownItem
            onClick={goToSsdeepPage}
            data-testid="ssdeep_to_search_filter_item_similar_by_ssdeep_hash_similarity"
          >
            Similar by SSDEEP Hash
          </DropdownItem>
        </RenderWhen>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default FileSimilarityFilter;
